/** The index of the invoice page's review tab — the last group, after the four general tabs. */
const REVIEW_TAB_INDEX = 4;

/**
 * The address of an invoice's review tab, where its approvals are decided.
 *
 * @param incomingInvoiceId - The invoice.
 * @returns The path, with the tab selected through the query string `Tabs` reads.
 */
export function incomingInvoiceReviewPath(incomingInvoiceId: string) {
	return `/controlling/incoming-invoices/${incomingInvoiceId}?incoming-invoice-tabs=${REVIEW_TAB_INDEX}`;
}
